import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hwTypeSelect", "powerInput", "nameField"]

  updateName() {
    const hwTypeSelect = this.hwTypeSelectTarget
    const powerInput = this.powerInputTarget
    const nameField = this.nameFieldTarget

    const hwTypeName = hwTypeSelect.options[hwTypeSelect.selectedIndex]?.text || ""
    const power = powerInput.value || ""

    if (hwTypeName && hwTypeName !== "Select" && power) {
      nameField.value = `${hwTypeName} - ${power}kW`
      nameField.classList.remove("opacity-50")
    } else {
      nameField.value = ""
      nameField.classList.add("opacity-50")
    }
  }
}
